import React, { useEffect, useState } from "react";
import Header from "../../../common/header/header";
import Nav from "../nav";
import { Button, Select, TextInput } from "@mantine/core";
import { IconChevronDown } from "@tabler/icons-react";
import { useLocation } from "react-router-dom";

const WellheadGasPrice = () => {
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedZone, setSelectedZone] = useState("");
  const [crudeOilPrice, setCrudeOilPrice] = useState("");
  const [usdPkrRate, setUsdPkrRate] = useState("");
  const [result, setResult] = useState({ usd: 0, pkr: 0 });
  const [resultsdata, setResultsData] = useState(null);
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const icon = <IconChevronDown size={16} />;

  const calculateWellheadGasPrice = () => {
    const Crude_Oil = parseFloat(crudeOilPrice);
    const USD_PKR = parseFloat(usdPkrRate);

    const B4 = 10;
    const C4 = 30;
    const B5 = 30;
    const C5 = 50;
    const B6 = 50;
    const C6 = 70;
    const B7 = 70;
    const C7 = 110;

    let Z1, Z2, Z3, Z4;

    if (Crude_Oil > C4) {
      Z1 = C4;
    } else {
      if (Crude_Oil < B4) {
        Z1 = B4;
      } else {
        Z1 = Crude_Oil;
      }
    }

    if (Crude_Oil >= C5) {
      Z2 = C5 - B5;
    } else {
      if (Crude_Oil < B5) {
        Z2 = 0;
      } else {
        Z2 = Crude_Oil - B5;
      }
    }

    if (Crude_Oil >= C6) {
      Z3 = C6 - B6;
    } else {
      if (Crude_Oil < B6) {
        Z3 = 0;
      } else {
        Z3 = Crude_Oil - B6;
      }
    }

    if (Crude_Oil >= C7) {
      Z4 = C7 - B7;
    } else {
      if (Crude_Oil < B7) {
        Z4 = 0;
      } else {
        Z4 = Crude_Oil - B7;
      }
    }

    const Applicable_CrudeOil_Price = Z1 * 1 + Z2 * 0.5 + Z3 * 0.3 + Z4 * 0.2;
    let MarkerPriceOnshore_ZoneIII;

    switch (selectedZone) {
      case "ZONE III":
        MarkerPriceOnshore_ZoneIII = Applicable_CrudeOil_Price * 0.6333;
        break;
      case "ZONE II":
        MarkerPriceOnshore_ZoneIII = Applicable_CrudeOil_Price * 0.665;
        break;
      case "ZONE I":
        MarkerPriceOnshore_ZoneIII = Applicable_CrudeOil_Price * 0.6966;
        break;
      case "ZONE O (SHALLOW) and ZONE-I(F)":
        MarkerPriceOnshore_ZoneIII = Applicable_CrudeOil_Price * 0.7388;
        break;
      case "ZONE O (DEEP)":
        MarkerPriceOnshore_ZoneIII = Applicable_CrudeOil_Price * 0.8444;
        break;
      case "ZONE O (ULTRADEEP)":
        MarkerPriceOnshore_ZoneIII = Applicable_CrudeOil_Price * 0.95;
        break;
      default:
        MarkerPriceOnshore_ZoneIII = 0;
        break;
    }

    const ConversionFactor = 5.7;
    const ZoneIII_Wellhead_Gasprice_USDperMMBTU =
      MarkerPriceOnshore_ZoneIII / ConversionFactor;
    const ZoneIII_Wellhead_Gasprice_PKRperMMBTU =
      (MarkerPriceOnshore_ZoneIII / ConversionFactor) * USD_PKR;

    setResult({
      usd: ZoneIII_Wellhead_Gasprice_USDperMMBTU,
      pkr: ZoneIII_Wellhead_Gasprice_PKRperMMBTU,
    });

    setResultsData({
      usd: ZoneIII_Wellhead_Gasprice_USDperMMBTU,
      pkr: ZoneIII_Wellhead_Gasprice_PKRperMMBTU,
    });
  };

  return (
    <>
      <Header />
      <div className="row omcboxed" style={styles.navWidth}>
        <Nav nopadding={true} />
      </div>
      <div className="wellhead-boxed">
        <div className="container container_box">
          <div className="main-wellhead">
            <div className="row">
              <div className="col-md-6">
                <div className="wellhead-filter">
                  <div className="wellhead-flex-field">
                    <div className="well-head-search-field">
                      <Select
                        label="Petroleum Policy"
                        placeholder="Petroleum Policy"
                        rightSection={icon}
                        data={["2012"]}
                        value={selectedYear}
                        onChange={(value) => setSelectedYear(value)}
                      />
                    </div>
                    <div className="well-head-search-field">
                      <Select
                        label="Type of Well"
                        placeholder="Type of Well"
                        rightSection={icon}
                        data={[
                          "ZONE III",
                          "ZONE II",
                          "ZONE I",
                          "ZONE O (SHALLOW) and ZONE-I(F)",
                          "ZONE O (DEEP)",
                          "ZONE O (ULTRADEEP)",
                        ]}
                        value={selectedZone}
                        onChange={(value) => {
                          setSelectedZone(value);
                          setResult({ usd: 0, pkr: 0 });
                        }}
                      />
                    </div>
                  </div>
                  <div className="wellhead-flex-field">
                    <div className="well-head-search-field">
                      <TextInput
                        label="Crude Oil Price per bbl"
                        placeholder="Enter Crude Oil Price"
                        value={crudeOilPrice}
                        onChange={(event) =>
                          setCrudeOilPrice(event.target.value)
                        }
                      />
                    </div>
                    <div className="well-head-search-field">
                      <TextInput
                        label="USD/PKR Rate"
                        placeholder="Enter USD/PKR Rate"
                        value={usdPkrRate}
                        onChange={(event) => setUsdPkrRate(event.target.value)}
                      />
                    </div>
                  </div>
                  <div className="search-clear-button">
                    <Button
                      className="search-btn-stle"
                      onClick={calculateWellheadGasPrice}
                    >
                      Search
                    </Button>
                  </div>
                </div>
              </div>
              {resultsdata && (
                <div className="col-md-5">
                  <div className="result-box">
                    <h3>Results:</h3>
                    <div className="price-boxes wellhead-table">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>Wellhead Gas Price for USD/MMBTU:</th>
                            <th>{result.usd.toFixed(1)}</th>
                          </tr>
                          <tr>
                            <th>Wellhead Gas Price for PKR/MMBTU:</th>
                            <th>{result.pkr.toFixed(0)}</th>
                          </tr>
                        </thead>
                      </table>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const styles = {
  navWidth: {
    width: "100%",
    fontSize: "14px",
    margin: "auto",
    marginBottom: "10px",
    justifyContent: "space-between",
  },
};

export default WellheadGasPrice;
